// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#img-ly-scene-import-dropzone[data-v-ddaaf242]{min-height:126px}#img-ly-scene-import-add-files[data-v-ddaaf242]{padding-top:45px}.dz-uploaded-file[data-v-ddaaf242]{cursor:default}", ""]);
// Exports
module.exports = exports;
